module.exports = __webpack_public_path__ + "static/media/sad-kiano.f1503720.png";